var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',{staticClass:"pa-4",attrs:{"loading":_vm.loading}},[(_vm.code)?_c('confirm-code-view',{attrs:{"success":_vm.success,"loading":_vm.loading}}):_c('sign-up-email-confirm-code',{on:{"back":_vm.onLogout,"login":_vm.onLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }